<template>
  <li v-if="!isHidden" class="bulkRow">
    <div
      class="bulkChangeOrderId clickable"
      @click="navigateToDetailsPage(bulkChangeOrder.BulkChangeOrderId)"
    >
      {{ bulkChangeOrder.BulkChangeOrderId }}
    </div>
    <div class="date clickable" @click="navigateToDetailsPage(bulkChangeOrder.BulkChangeOrderId)">
      {{ bulkChangeOrder.CreateDate }}
    </div>
    <div
      class="komNumbers clickable"
      @click="navigateToDetailsPage(bulkChangeOrder.BulkChangeOrderId)"
    >
      {{ getNumberOfKomNumber }}
    </div>
    <div
      class="salesemployee clickable"
      @click="navigateToDetailsPage(bulkChangeOrder.BulkChangeOrderId)"
    >
      {{ bulkChangeOrder.EmployeeName }}
    </div>
    <div class="status clickable" @click="navigateToDetailsPage(bulkChangeOrder.BulkChangeOrderId)">
      {{ getBulkChangeOrderStatus }}
    </div>
    <div class="actions">
      <app-button
        button-class="icon-stack"
        data-qa="bulk-change-order-pause-or-start-button"
        :disabled="isStartOrPauseButtonDisabled"
        @click="togglePauseOrStart"
      >
        <span class="btn-icon">{{ getStartOrPauseButtonIcon }}</span>
        <span class="btn-label">{{ getStartOrPauseButtonLabel }}</span>
      </app-button>
      <app-button
        button-class="icon-stack"
        data-qa="bulk-change-order-delete-button"
        @click="toggleDeleteConfirmModal(true)"
      >
        <span class="btn-icon">&#x1F5D1;</span>
        <span class="btn-label">archief</span>
      </app-button>
    </div>

    <modal
      v-if="showDeleteConfirmModal"
      :title="i18n.t('/Common/Confirmation')"
      @close="toggleDeleteConfirmModal(false)"
    >
      <p>
        {{ i18n.t('/change-order/bulk/discard-confirm') }}
      </p>
      <app-button
        data-qa="delete-bulk-change-order-cancel-button"
        @click="toggleDeleteConfirmModal(false)"
        >{{ i18n.t('/Common/Cancel') }}</app-button
      >
      <app-button data-qa="delete-bulk-change-order-confirm-button" @click="confirmDelete">{{
        i18n.t('/Common/Delete')
      }}</app-button>
    </modal>
    <loader v-if="isDeleting" />
  </li>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import bulkChangeOrderService from '@/services/bulkChangeOrderService.js'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import BulkChangeOrderStatus from '@/helpers/enums/bulkChangeOrderStatus'

export default {
  components: { Modal, AppButton, Loader },
  props: {
    bulkChangeOrder: {
      type: Object,
      required: true,
    },
  },
  emits: ['pause', 'resume'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showDeleteConfirmModal: false,
      isHidden: false,
      isDeleting: false,
    }
  },
  computed: {
    getNumberOfKomNumber() {
      return this.bulkChangeOrder.OriginalExcelRows.length
    },
    getBulkChangeOrderStatus() {
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.concept) {
        return 'CONCEPT'
      }
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.readyForProcessing) {
        return 'IN WACHTRIJ'
      }
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.processing) {
        return 'WORDT VERWERKT'
      }
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.paused) {
        return 'GEPAUZEERD'
      }
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.checked) {
        return 'ORDER GECHECKED'
      }
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.processed) {
        return 'ORDER GEWIJZIGD'
      }
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.error) {
        return 'ERROR'
      }
      return 'STATUS ONBEKEND'
    },
    isStartOrPauseButtonDisabled() {
      return (
        this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.concept ||
        this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.checked ||
        this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.processed
      )
    },
    getStartOrPauseButtonIcon() {
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.paused) {
        return '▶'
      }
      return '⏸'
    },
    getStartOrPauseButtonLabel() {
      if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.paused) {
        return 'start'
      }
      return 'pauzeren'
    },
  },
  methods: {
    navigateToDetailsPage(bulkChangeOrderId) {
      this.$router.push({
        name: 'bulk-change-order-page',
        params: {
          ...this.$route.params,
          bulkChangeOrderId: bulkChangeOrderId,
        },
      })
    },
    async togglePauseOrStart() {
      try {
        if (!this.isStartOrPauseButtonDisabled) {
          if (
            this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.processing ||
            this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.readyForProcessing
          ) {
            await bulkChangeOrderService.pauseBulkChangeOrder(
              this.bulkChangeOrder.BulkChangeOrderId
            )
            this.$emit('pause')
          } else if (this.bulkChangeOrder.BulkOrderStatus === BulkChangeOrderStatus.paused) {
            await bulkChangeOrderService.resumeBulkChangeOrder(
              this.bulkChangeOrder.BulkChangeOrderId
            )
            this.$emit('resume')
          }
        }
      } catch {}
    },
    toggleDeleteConfirmModal(showModal) {
      this.showDeleteConfirmModal = showModal
    },
    async confirmDelete(e) {
      e.stopPropagation()
      this.isDeleting = true
      try {
        await bulkChangeOrderService.deleteBulkChangeOrder(this.bulkChangeOrder.BulkChangeOrderId)
        this.isHidden = true
        this.toggleDeleteConfirmModal(false)
      } catch (error) {
        console.error('Error deleting bulk change order:', error)
      } finally {
        this.isDeleting = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bulkRow {
  display: grid;
  grid-template-columns: 5em 10em 10em 15em 10em 10em;
  grid-template-areas: 'bulkChangeOrderId date komNumbers salesemployee status actions';
  border-bottom: 1px solid #dae2e5;
  padding: 0.5rem;
}

li.row:hover {
  background-color: #fafbfc;
}

.actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.bulkChangeOrderId,
.date,
.komNumbers,
.salesemployee {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.status {
  display: flex;
  flex-direction: column;
}

.clickable {
  cursor: pointer;
}
</style>
